module.exports = __webpack_public_path__ + "media/images/smart_phone/next-horizontal-ffc4fee13be3d4299afcb7f4cc0ea289.png";